initAccordion = function() {

    // Get all Accordion with Image modules on the page
    const accordions = document.querySelectorAll('.accordion-with-image');

    if ( accordions ) {
        // Loop through all modules
        accordions.forEach(accordion => {
            const drawers = accordion.querySelectorAll('.accordion-with-image__drawer');
            const initialImg = drawers[0].getAttribute('data-img');
            const img = accordion.querySelector('.accordion-with-image__image');

            // Set the initial image to the image associated with the first drawer
            img.src = initialImg;
        });
    }

    handleDrawerActions();
}

handleDrawerActions = function() {
    const accordions = document.querySelectorAll('.accordion-with-image');

    // Loop through all accordions on the page...
    accordions.forEach(accordion => {
        const drawers = accordion.querySelectorAll('.accordion-with-image__drawer');
        const image = accordion.querySelector('.accordion-with-image__image');

        // Loop through all the drawers in the accordion...
        drawers.forEach(object => {
            // On click of an accordion drawer
            object.addEventListener('click', (e) => {
                let clickedDrawer = e.target.closest('.accordion-with-image__drawer');
                let newImgSrc = clickedDrawer.getAttribute('data-img');
                let newImgAlt = clickedDrawer.getAttribute('data-alt');

                // Close all the accordion drawers
                drawers.forEach(obj => {
                    obj.classList.add('accordion-with-image__drawer--closed');
                })

                // Open the clicked drawer
                clickedDrawer.classList.remove('accordion-with-image__drawer--closed');

                // Set the new image
                image.src = newImgSrc;
                image.alt = newImgAlt;
            })
        })
    })
}



// check to see if we are on the frontend or in admin
if ( window.acf ) {
    // initialize dynamic block preview (editor)
    window.acf.addAction( 'render_block_preview/type=accordion-with-image', initAccordion);
}
else {
    // initialize on frontend
    initAccordion();
}